import { render, staticRenderFns } from "./vueCarousel.vue?vue&type=template&id=bf595748&scoped=true&"
import script from "./vueCarousel.vue?vue&type=script&lang=ts&"
export * from "./vueCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./vueCarousel.vue?vue&type=style&index=0&id=bf595748&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf595748",
  null
  
)

export default component.exports